/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, SimpleAttributeList, simpleLocalAttribute } from './SimpleAttribute';
import { DefaultSplitDataRenderType, SplitData } from './SplitData';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface RoleFields {
	roleName: string;
	roleId: string;
	roleColor: string;
	color?: string;
	workShiftsByDow?: number[];
}

export class Role extends SplitData<RoleFields, DefaultSplitDataRenderType> {
	protected useInPlace: boolean = true;
	protected attributeList: SimpleAttributeList = Object.assign(
		generateSimplestList(['roleName', 'roleId', 'roleColor', 'workShiftsByDow']),
		{
			color: simpleLocalAttribute,
		}
	);

	public constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
